import { jsxs as o, jsx as a } from "react/jsx-runtime";
const E = (h) => {
  const {
    name: m,
    id: r,
    placeholder: p,
    reference: x,
    error: u,
    label: t,
    message: d,
    helpText: i,
    disabled: b,
    row: v,
    rows: T,
    defaultValue: g,
    maxLength: w,
    testId: e,
    describedById: N
  } = h, n = !!u, s = n && !!d, l = !!i, c = N || (r ? `${r}-error-help` : void 0), f = s || l, B = T ?? v;
  return /* @__PURE__ */ o("div", { className: "Textarea-group", children: [
    t && /* @__PURE__ */ a(
      "label",
      {
        className: "Input-label",
        htmlFor: r,
        "data-testid": e ? `${e}-label` : void 0,
        children: t
      }
    ),
    /* @__PURE__ */ a(
      "textarea",
      {
        className: ["Textarea", n ? "Textarea--error" : ""].filter(Boolean).join(" "),
        id: r,
        name: m,
        rows: B,
        disabled: b,
        "aria-describedby": f ? c : void 0,
        placeholder: p,
        ref: x,
        defaultValue: g,
        maxLength: w,
        "data-testid": e ? `${e}-textarea` : void 0
      }
    ),
    (s || l) && /* @__PURE__ */ o("ul", { id: c, children: [
      s && /* @__PURE__ */ o(
        "li",
        {
          className: "Form-help Form-help--error",
          "data-qa": "TextareaError-" + r,
          "data-testid": e ? `${e}-message` : void 0,
          children: [
            /* @__PURE__ */ a(
              "span",
              {
                "data-testid": e ? `${e}-warning` : void 0,
                "aria-hidden": "true",
                children: "warning"
              }
            ),
            /* @__PURE__ */ a("span", { className: "u-hiddenVisually", children: "Error," }),
            /* @__PURE__ */ a("span", { children: d })
          ]
        }
      ),
      l && /* @__PURE__ */ a("li", { className: "Form-help", children: i })
    ] })
  ] });
};
export {
  E as Textarea
};
//# sourceMappingURL=Textarea.mjs.map
